import { defineComponent, ref, watch } from 'vue';
import { EnvironmentOutlined } from '@ant-design/icons-vue';
import { LoginService } from '@/services/login.service';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import VCode from '@/components/VCode.vue';
import { useRoute } from 'vue-router';
import { SHOW_BRAND } from '@/utils';
import { environment } from '@/utils/environment';
import LoginDialogAccount from './LoginDialogAccount.vue';
import LoginDialogMobile from './LoginDialogMobile.vue';
import EventBusItemDetail from '@/eventBus/itemDetail';
export default defineComponent({
  name: 'LoginDialog',
  components: {
    VCode: VCode,
    EnvironmentOutlined: EnvironmentOutlined,
    LoginDialogAccount: LoginDialogAccount,
    LoginDialogMobile: LoginDialogMobile
  },
  props: {
    showCloseBtn: {
      type: Boolean,
      default: true
    }
  },
  setup: function (props) {
    var userService = useService(UserService);
    var loginService = useService(LoginService);
    var activeKey = ref('2');
    /**
     * ============================================
     * 需求：https://project.feishu.cn/ht-poject/story/detail/14341910
     * 需要根据活动id展示不同的HomeHeader，活动结束之后可删除
     * 线上 830是山东，该索引之前的都为山东    855是重庆 该索引之后的都是重庆
     * 测试环境 187是山东 该索引之前的都为山东 209是重庆 该索引之后的都是重庆 （210）
     */
    var specialActiveShandongList = environment === 'production' ? [1093, 830] : [187, 233];
    var specialActiveChongqinList = environment === 'production' ? [855] : [209, 210];
    var specialActiveList = specialActiveShandongList.concat(specialActiveChongqinList);
    var specialActiveFlag = ref(false); // 对应的特殊赛事活动
    var specialActiveType = ref(''); // 对应的特殊赛事活动
    var accountText = ref('');
    var passwdText = ref('');
    var route = useRoute();
    var itemDetailData = ref(null);
    watch(function () {
      return route.name;
    }, function (visible) {
      var currentItemId = '';
      if (visible === 'ItemDetail') {
        currentItemId = route.params.id;
        specialActiveType.value = specialActiveShandongList.includes(+currentItemId) ? '山东赛事' : specialActiveChongqinList.includes(+currentItemId) ? '重庆赛事' : '';
      } else if (visible === 'ActivityDetail') {
        currentItemId = route.params.itemId;
        specialActiveType.value = specialActiveShandongList.includes(+currentItemId) ? '山东赛事' : specialActiveChongqinList.includes(+currentItemId) ? '重庆赛事' : '';
      } else {
        currentItemId = '';
      }
      if (specialActiveList.includes(+currentItemId)) {
        specialActiveFlag.value = true;
        activeKey.value = '3';
      } else {
        specialActiveFlag.value = false;
        activeKey.value = '2';
      }
    }, {
      immediate: true
    });
    EventBusItemDetail.on('item-new', function (item) {
      // console.log('EventBusItemDetail --> 1222 item-new', item);
      itemDetailData.value = item;
      if (!item.showBrandSign && item.thirdPlatformName) {
        specialActiveFlag.value = true;
        specialActiveType.value = item.thirdPlatformName;
        accountText.value = item.accountText;
        passwdText.value = item.passwdText;
        activeKey.value = '3';
      } else if (!item.showBrandSign && !item.thirdPlatformName) {
        specialActiveFlag.value = false;
        specialActiveType.value = '';
        accountText.value = '';
        passwdText.value = '';
        activeKey.value = '2';
      } else {
        specialActiveFlag.value = false;
        specialActiveType.value = '2';
        accountText.value = '';
        passwdText.value = '';
      }
    });
    // ============================================
    return {
      userService: userService,
      loginService: loginService,
      SHOW_BRAND: SHOW_BRAND,
      props: props,
      activeKey: activeKey,
      specialActiveFlag: specialActiveFlag,
      specialActiveType: specialActiveType,
      itemDetailData: itemDetailData,
      accountText: accountText,
      passwdText: passwdText
    };
  }
});